import { createContext, use } from 'react';
import { SearchFacet, SearchResults, SuggestionResults } from '#server/models';

export interface SearchContextType {
  suggestionsQuery: string;
  facet: SearchFacet;
  setSuggestionsQuery: (query: string) => void;
  setSearchQuery: (query: string) => void;
  setSearchAndSuggestionQuery: (query: string) => void;
  setFacet: (facet: SearchFacet) => void;
  setPage: (facet: SearchFacet, page: number) => void;
  searchQuery: string | null;
  suggestionResults?: SuggestionResults;
  searchResults?: SearchResults;
  loading: boolean;
  error: any;
}

export const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const useSearchContext = (): SearchContextType => {
  const context = use(SearchContext);
  if (!context) {
    throw new Error('useSearchContext must be used within a SearchProvider');
  }
  return context;
};
